// extracted by mini-css-extract-plugin
module.exports = {"item":"QuoteItem_item__2TM7-"};